import { useEffect } from 'react';
import './Help.css';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import httpClient from '../../HTTPService';
import moment from 'moment';
import user from '../../assets/user.png';

const Replay = () => {
    const [msgData, setMsgData] = useState();
    const [messageDetail, setmessageDetails] = useState({})
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const type_list = queryParams.get('type');
    const [adminAnswer, setAnswer] = useState();
    const navigate = useNavigate()
    const params = useParams();
    // let { id } = params
    const [sitesettingData, setsitesettingData] = useState({})
    const match = type_list?.match(/^(\d+)([a-zA-Z]+)$/);
    const number = match[1]; // "2"
    const text = match[2];
    useEffect(() => {
        if (match[2] !== 'webhelp') {
            // "webhelp"
            fetchreplydetails()

        } else {
            fetwebhelpDetails()
        }
        // console.log(type, 'type///.>>>>>>>>>>>')
        getsitesettingDetails()

    }, [])
    // Message Replay
    const fetchreplydetails = async () => {
        try {
            const result = await httpClient.post("/admin/helps/view", { id: number }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            if (result.data.status == true) {
                setmessageDetails(result?.data?.data)
                setAnswer(result?.data?.data?.answer)
            }
            if (result.data.status == false) {
                toast.error(result.data.message)
            }

        }

        catch (error) {
            toast.error(error.message)
        }
    }

    // fetch web help details
    const fetwebhelpDetails = async () => {
        try {
            const result = await httpClient.post("/admin/web-help/view", { id: number }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            if (result.data.status == true) {
                setmessageDetails(result?.data?.data)
                setAnswer(result?.data?.data?.answer)
            }
            if (result.data.status == false) {
                toast.error(result.data.message)
            }

        }

        catch (error) {
            toast.error(error.message)
        }
    }
    // Message Replay
    const sendRply = async () => {
        try {
            const result = await httpClient.post(`${match[2] !== 'webhelp' ? '/admin/helps/update ' : '/admin/web-help/update'}`, { id: number, answer: adminAnswer }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            if (result.data.status == true) {
                toast.success(result.data.message)
                setTimeout(() => {
                    if (match[2] !== 'webhelp') {
                        navigate('/help')
                    } else {
                        navigate('/webhelp')
                    }

                })
            }
            if (result.data.status == false) {
                toast.error(result.data.message)
            }

        }

        catch (error) {
            toast.error(error.message)
        }
    }

    const getsitesettingDetails = async () => {
        try {
            const result = await httpClient.post('/admin/site-settings', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            if (result.status === 200) {
                setsitesettingData(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    return (
        <div className="replay">
            <ToastContainer
                autoClose={1000}
            />
            <div className='card'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='formGroup'>
                            <div>
                                <p>Question</p>
                                <div style={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: 100
                                }}>
                                    <img

                                        src='https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_hybrid&w=740'
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />

                                </div>
                                <div style={{
                                    width: 400,
                                    backgroundColor: '#e1e39a',
                                    height: 'auto',
                                    borderRadius: 12,

                                    paddingLeft: 10,
                                    paddingTop: 7,
                                    paddingBottom: 7,
                                    // borderTopLeftRadius: 10,
                                    // borderBottomLeftRadius: 160,
                                    marginLeft: 30
                                }}>
                                    <p style={{
                                        padding: 0,
                                        margin: 0, paddingLeft: 40
                                    }}>{match[2] !== 'webhelp' ? messageDetail?.question : messageDetail?.message} </p>
                                    <p style={{
                                        padding: 0,
                                        margin: 0,
                                        paddingLeft: 40
                                    }}>{moment(messageDetail?.date).format('DD/MM/YYYY')}</p>
                                </div>


                            </div>
                            {
                                messageDetail?.answer && (
                                    <div style={{
                                        marginTop: 20
                                    }}>
                                        <div style={{
                                            width: 420,
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            <div></div>
                                            <div style={{
                                                width: 50,
                                                height: 50,
                                                borderRadius: 100,
                                                border: '1px solid #5abf86'
                                                // marginLeft:40/
                                            }}

                                            >
                                                <img

                                                    src={sitesettingData?.logo_path}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'contain'
                                                    }}
                                                />

                                            </div>
                                        </div>
                                        <div style={{
                                            width: 400,
                                            backgroundColor: '#5abf86',
                                            height: 'auto',
                                            borderRadius: 12,

                                            paddingLeft: 10,
                                            paddingTop: 7,
                                            paddingBottom: 7,
                                            // borderTopRightRadius: 10,
                                            // borderBottomRightRadius: 160,
                                            marginTop: 10
                                        }}>
                                            <p style={{
                                                padding: 0,
                                                margin: 0, paddingLeft: 40, color: 'white'
                                            }}> {messageDetail?.answer && messageDetail?.answer}</p>
                                            <p style={{
                                                padding: 0,
                                                margin: 0,
                                                paddingLeft: 40, color: 'white'
                                            }}>{moment(messageDetail?.answer_date).format('DD/MM/YYYY')}</p>
                                        </div>


                                    </div>
                                )}

                            <div style={{
                                marginTop: 40
                            }}>
                                <p>Comments: </p>
                                <textarea
                                    disabled={messageDetail?.status == 1 ? true : false}
                                    value={adminAnswer} placeholder='Please Type answer' onChange={(val) => { setAnswer(val.target.value) }}></textarea>

                            </div>
                        </div>
                        <div className='btnFlx'>
                            <button type='button' className='addBtn' onClick={() => { navigate('/help'); localStorage.removeItem('rply') }}>Cancel</button>
                            <button type='button' className='addBtn' onClick={sendRply}>Repaly</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Replay;